import Reviews from "../../layouts/Reviews";
import AlbumReviewTable from "../../components/reviews/AlbumReviewTable";

export default function AlbumReviews() {

    const rightContent = (
        <div>
            <AlbumReviewTable/>
        </div>
    )
    return (
        <div className="album-reviews-page">
            <Reviews rightContent={rightContent}/>
        </div>
    )
}
